import React, { useEffect, useState } from 'react';
import { Country, State } from 'country-state-city';


const Check = () => {

  const [show, setShow] = useState({
    states: false,
  });

  // --- Country --- 

  const [countries, setCountries] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState({
    countryCode: 'IN',
    countryName: 'India',
    lat: '20.00000000',
    lng: '77.00000000',
  });

  // Handle country selection
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
  
    // Find the country object based on the selected country code
    const country = countries.find(c => c.isoCode === countryCode);
  
    if (country) {
      setSelectedCountry({
        countryName: country.name,
        countryCode: country.isoCode,
        lat: country.latitude,
        lng: country.longitude,
      });
    };

    // Get states of the selected country
    const statesList = State.getStatesOfCountry(countryCode);

    setStates(statesList);
  };


  // --- States --- 

  const [stateText, setStateText] = useState('');
  const [states, setStates] = useState([]);                   // Search State List
  const [selectedStates, setSelectedStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);


  // console.log('searched : ', states);
  // console.log('selected : ', selectedStates);
  console.log('filtered : ', filteredStates);

  // handle state change
  const handleStateChange = (e) => {
    setStateText(e.target.value);

    // Filter states based on input
    const filtered = states.filter((state) =>
      state.name.toLowerCase().includes(e.target.value.toLowerCase())
    );

    setFilteredStates(filtered);
  };

  // handle switch selected state from searched list to selected list
  const handleStateSearchToSelect = (state) => {
    // Add the selected state to selectedStates
    setSelectedStates((prevSelectedStates) => [...prevSelectedStates, state]);
  
    // Remove the selected state from the states list
    setStates((prevStates) => prevStates.filter((s) => s.isoCode !== state.isoCode));
  };
  
  // handle switch selected state from selected list to searched list
  const handleStateSelectToSearch = (state) => {
    // Remove the selected state from the selected states list
    setSelectedStates((prevSelectedStates) => prevSelectedStates.filter((s) => s.isoCode !== state.isoCode));

    // Add the selected state to the searched states list
    setStates((prevStates) => [...prevStates, state]);
  };
  



  

  useEffect(() => {
    // --- Country ---
    const countryList = Country.getAllCountries();
    
    setCountries(countryList);

    // --- States ---
    const statesList = State.getStatesOfCountry(selectedCountry.countryCode);

    setStates(statesList);
  }, []);

  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        <h4 className='text-center mn-0'>Google Map Platform</h4>

        {/* Country */}
        <div className='mb-3'>
          <label>Country</label>

          <select className='form-select' value={selectedCountry.countryCode} onChange={handleCountryChange}>
            <option value="" disabled>Select a country</option>

            {
              countries.map((country, index) => (
                <option value={country.isoCode} key={index}>{country.name}</option>
              ))
            }
          </select>
        </div>

        {/* States */}
        <div className='position-relative'>
          <label>States</label>

          {/* Selected States List */}
          <>
            {
              selectedStates.length > 0
              &&
              <div className='bg-light p-2 rounded-3 d-flex align-items-center gap-3'>
                {
                  selectedStates.map((state, index) => (
                    <div className='cursor-pointer bg-primary d-flex align-items-center px-3 py-1 rounded-pill' key={index}>
                      <span className='text-white me-2'>{state.name}</span>
                      <span className='bg-danger px-2 pb-1 text-white rounded-circle cursor-pointer' onClick={() => handleStateSelectToSearch(state)}>x</span>
                    </div>
                  ))
                }
              </div>
            }
          </>

          <input type="search" className='form-control' placeholder='Search States...' 
            value={stateText} onChange={handleStateChange}
            onFocus={() => setShow({ ...show, states: true })} onBlur={() => setShow({ ...show, states: false })}
          />

          {/* Searched States List */}
          <>
            {
              show.states === true && filteredStates.length === 0 && states.length > 0
              // true
              &&
              <div className='bg-white p-3 rounded-3 mt-2 position-absolute w-100 overflow-scroll' style={{ maxHeight: '50vh' }}>
                {
                  states.map((state, index) => (
                    <>
                      <div className='cursor-pointer' onClick={() => handleStateSearchToSelect(state)} key={index}>{state.name}</div>

                      {states.length - 1 !== index && <hr className='my-1' />}
                    </>
                  ))
                }
              </div>
            }
          </>

          {/* Filtered States List */}
          <>
            {
              show.states === true && filteredStates.length > 0
              // true
              &&
              <div className='bg-white p-3 rounded-3 mt-2 position-absolute w-100 overflow-scroll' style={{ maxHeight: '50vh' }}>
                {
                  filteredStates.map((state, index) => (
                    <>
                      <div className='cursor-pointer' key={index}>{state.name}</div>

                      {filteredStates.length - 1 !== index && <hr className='my-1' />}
                    </>
                  ))
                }
              </div>
            }
          </>
        </div>
      </section>
    </>
  );
};

export default Check;